import { DEFAULT_NOTIFICATION } from '../../constants';

const createRemoveNotificationState = (state, payload = {}) => {
  const canUpdate = payload.notificationType
    ? payload.notificationType === state.notificationType
    : true;

  if (canUpdate) {
    return DEFAULT_NOTIFICATION;
  }

  return state;
};

export default createRemoveNotificationState;
